import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";

const FIELDS = {
  privacy: { field: "privacy_text", title: "Privacy Policy", overline: "Your data, respected" },
  terms: { field: "terms_text", title: "Terms of Use", overline: "The agreement between us" },
  guidelines: { field: "guidelines_text", title: "Community Guidelines", overline: "How we keep the hub safe" },
  about: { field: "about_text", title: "About Burmese Hub", overline: "Our mission" },
};

export default function PolicyPage({ kind }) {
  const [settings, setSettings] = useState(null);
  const meta = FIELDS[kind];

  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid={`policy-page-${kind}`}>
      <section className="bg-teak acheik-bg-dark text-cream py-14 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold mb-4">{meta.overline}</p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{meta.title}</h1>
        </div>
      </section>
      <section className="py-14 lg:py-20 bg-cream">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {!settings ? (
            <div className="h-64 rounded-2xl bg-sand animate-pulse" />
          ) : (
            <Reveal>
              <div className="bg-white border border-[#E6DED3] rounded-2xl p-6 sm:p-10" data-testid={`policy-content-${kind}`}>
                {(settings[meta.field] || "").split("\n\n").map((para, i) => {
                  const isHeading = para.startsWith("## ");
                  return isHeading ? (
                    <h2 key={i} className="font-display text-xl font-bold text-ink mt-8 mb-3 first:mt-0">{para.replace("## ", "")}</h2>
                  ) : (
                    <p key={i} className="text-clay text-sm sm:text-base leading-relaxed mb-4">{para}</p>
                  );
                })}
              </div>
            </Reveal>
          )}
          <p className="mt-8 text-xs text-stone2">Last updated September 2026 · Questions? admin@burmesehub.com</p>
        </div>
      </section>
    </div>
  );
}
